module.exports = __webpack_public_path__ + "static/img/325_TO8_2509.a219e4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/325_TO8_2509.jpg
// module id = KXeG
// module chunks = 0